import {TabsReducer} from '../../../common/tabs/tabs.reducer';
import {IDS} from './improvement-action-id.constants';

const tabs = [
    {
        state: IDS.app_accreditation_scheme_improvement_list,
        title: 'ACCREDITATION.IMPROVEMENT.LIST.TAB',
        visible: true,
        disabled: false,
        loading: false,
    },
    {
        state: IDS.app_accreditation_scheme_improvement_action,
        title: 'ACCREDITATION.IMPROVEMENT.DETAILS.TAB',
        visible: true,
        disabled: true,
        loading: false
    },
    {
        state: IDS.app_accreditation_scheme_improvement_action_plan,
        title: 'ACCREDITATION.IMPROVEMENT.ACTION_PLAN.TAB',
        visible: true,
        disabled: true,
        loading: false
    },
    {
        state: IDS.app_accreditation_scheme_improvement_step,
        title: 'ACCREDITATION.IMPROVEMENT.STEP.TAB',
        visible: true,
        disabled: true,
        loading: false,
        buttons: {
            execute: { label: "Save Changes" },
        },
    },
    {
        state: IDS.app_accreditation_scheme_improvement_add_action,
        title: 'ACCREDITATION.IMPROVEMENT.ADD.TAB',
        visible: false,
        disabled: false,
        loading: false,
    },

];

export const improvementTabs = {
    [IDS.app_accreditation_scheme_improvement]: Object.assign(TabsReducer(), { tabs }),
    // [IDS.public_accreditation_scheme_improvement]: Object.assign(TabsReducer(), { tabs: publicTabs })
}
